import React from "react"
import { connect } from 'react-redux'
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

// core components
import GridContainer from "components/GridContainer"
import GridItem from "components/GridItem"
import Card from "components/Card"
import CardBody from "components/CardBody"
import CardHeader from "components/CardHeader"

import extendedTablesStyle from "./extendedTablesStyle.jsx"

import { primaryColor } from "../../assets/jss/material-dashboard-pro-react";
import { mapService } from "../../_services";

import ReactTable from "../../components/react-table";
import Button from "../../components/CustomButtons";
import { sweetAlertActions } from "../../_actions";
import CustomInput from "../../components/CustomInput";
import {update_greenhouse_list} from "../helper_functions/locations";
import ClipboardButton from "../../components/ClipboardButoon";
import MyDropdown from "../../components/MyDropdown";
import Table from "../../components/Table";
import { getUserType } from "../../_services/authenticate";

class Greenhouses extends React.Component {
  requiredFields = ["name", "location_id"];
  constructor(props) {
    super(props)
    this.state = {
      totalResults: 0,
      totalPages: 0,
      pageSize: 10,
      currentPage: 1,
      show_deactivated: false,
      loading: false,
      updated_properties: {},
      data: [],
      update_greenhouse: null,
      create_greenhouse: false,
      field_errors: {},
      crop_types: {
        "tomato": "Tomato",
        "cucumber": "Cucumber",
        "strawberry": "Strawberry",
        "cut_flower": "Cut Flower",
        "bell_pepper": "Bell Pepper"
      }
    }

    this.timer = null
    this._is_mounted = false
  }

  componentDidMount() {
    this._is_mounted = true
    this.refresh()
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
    this._is_mounted = false
  }

  refresh() {
    const {currentPage, pageSize, show_deactivated} = this.state
    this.setState({loading: true})

    mapService.getGreenhouses(pageSize, currentPage - 1, show_deactivated, result => {
      const total_pages = Math.ceil(result.total / pageSize)
      let newCurrentPage = currentPage
      if (currentPage > total_pages && result.total > 0) {
        newCurrentPage = total_pages
      }
      this.setState({
        totalResults: result.total,
        currentPage: newCurrentPage,
        data: result.results,
        totalPages: total_pages,
        loading: false,
      })
    }, error => {
      this.setState({
        data: [],
        totalPages: 0,
        loading: false
      })
    });
  }

  change_value(value_name, value) {
    let { updated_properties, field_errors } = this.state;
    updated_properties[value_name] = value;
    // Validate the field immediately
    if (this.requiredFields.includes(value_name) && (!value || value.toString().trim() === "")) {
      field_errors[value_name] = `${this.getFieldLabel(value_name)} is required.`;
    } else {
      delete field_errors[value_name];
    }
    this.setState({ updated_properties, field_errors });
  }

  getFieldLabel(field) {
    // Map field names to user-friendly labels
    switch (field) {
      case "name": return "Name";
      case "client_name": return "Client Name";
      case "location_id": return "Location";
      default: return field.charAt(0).toUpperCase() + field.slice(1);
    }
  }

  toggle_show_deactivated() {
    const {show_deactivated} = this.state
    this.setState({show_deactivated: !show_deactivated }, () => this.refresh());
  }

  start_creating_greenhouse() {
    // Validate all fields on form open so errors show immediately
    const errors = this.validate_new_greenhouse_fields(this.state.updated_properties);
    this.setState({create_greenhouse: true, field_errors: errors });
  }

  start_updating_greenhouse(greenhouse) {
    this.setState({update_greenhouse: greenhouse})
  }

  clear_popup() {
    const {dispatch} = this.props;
    dispatch(sweetAlertActions.clear())
  }

  deactivate_greenhouse(greenhouse) {
    const {dispatch} = this.props;
    mapService.updateGreenhouse(greenhouse.id, null, null, null, null, true,res => {
      dispatch(sweetAlertActions.success({title: "Greenhouse is deactivated"}))
      update_greenhouse_list()
      this.refresh()
    }, error => {
      dispatch(sweetAlertActions.danger({ title: `Error deactivating ${greenhouse.name}.` }))
    })
  }

  activate_greenhouse(greenhouse) {
    const {dispatch} = this.props;
    mapService.updateGreenhouse(greenhouse.id, null, null, null, null, false,res => {
      dispatch(sweetAlertActions.success({title: "Greenhouse is activated"}))
      update_greenhouse_list()
      this.refresh()
    }, error => {
      dispatch(sweetAlertActions.danger({ title: `Error activating ${greenhouse.name}.` }))
    })
  }

  start_deactivating_greenhouse(greenhouse) {
    const {dispatch} = this.props;
    dispatch(sweetAlertActions.clean({
      title: "Are you sure?",
      showCancel: true,
      onCancel: this.clear_popup.bind(this),
      cancelBtnText: "No",
      onConfirm: this.deactivate_greenhouse.bind(this, greenhouse),
      confirmBtnText: "Yes",
      content: <div>
        <h5>You will deactivate <b>{greenhouse.name}</b></h5>

        <p>Only a Nimbus System Admin can reverse this.</p>
        <br/>
        <p><b>ID:</b>{greenhouse.id}</p>
        <p><b>Location ID:</b>{greenhouse.location_id}</p>


      </div>
    }))
  }

  start_activating_greenhouse(greenhouse) {
    const {dispatch} = this.props;
    dispatch(sweetAlertActions.clean({
      title: "Are you sure?",
      showCancel: true,
      onCancel: this.clear_popup.bind(this),
      cancelBtnText: "No",
      onConfirm: this.activate_greenhouse.bind(this, greenhouse),
      confirmBtnText: "Yes",
      content: <div>
        <h5>You will activate <b>{greenhouse.name}</b></h5>
        <br/>
        <p><b>ID:</b>{greenhouse.id}</p>
        <p><b>Location ID:</b>{greenhouse.location_id}</p>
      </div>
    }))
  }

  do_update_greenhouse(greenhouse) {
    const {updated_properties} = this.state
    const {dispatch} = this.props;

    let greenhouse_id = greenhouse["id"]
    let new_name = undefined
    if (updated_properties["name"] !== undefined && updated_properties["name"] !== "") {
      if (updated_properties["name"] !== greenhouse["name"]) {
        new_name = updated_properties["name"]
      }
    }

    let new_client_name = undefined
    if (updated_properties["client_name"] !== undefined && updated_properties["client_name"] !== "") {
      if (updated_properties["client_name"] !== greenhouse["client_name"]) {
        new_client_name = updated_properties["client_name"]
      }
    }

    let new_map_id = undefined
    if (updated_properties["map_id"] !== undefined && updated_properties["map_id"] !== "") {
      if (updated_properties["map_id"] !== greenhouse["map_id"]) {
        new_map_id = updated_properties["map_id"]
      }
    }

    let new_crop_type = undefined
    if (updated_properties["crop_type"] !== undefined && updated_properties["crop_type"] !== "") {
      if (updated_properties["crop_type"] !== greenhouse["crop_type"]) {
        new_crop_type = updated_properties["crop_type"]
      }
    }

    let new_location_id = undefined
    if (updated_properties["location_id"] !== undefined && updated_properties["location_id"] !== "") {
      if (updated_properties["location_id"] !== greenhouse["location_id"]) {
        new_location_id = updated_properties["location_id"]
      }
    }

    mapService.updateGreenhouse(greenhouse_id, new_name, new_client_name, new_map_id, new_location_id, null,res => {
      dispatch(sweetAlertActions.success({title: "Greenhouse is updated"}))
      update_greenhouse_list()
      this.setState({
        updated_properties: {},
        update_greenhouse: null
      }, () => this.refresh())
    }, error => {
      dispatch(sweetAlertActions.danger({ title: "Error updating the greenhouse" }))
    },
    new_crop_type)
  }

  validate_new_greenhouse_fields(properties) {
    const errors = {};
    this.requiredFields.forEach(field => {
      if (!properties[field] || properties[field].toString().trim() === "") {
        errors[field] = `${this.getFieldLabel(field)} is required.`;
      }
    });
    return errors;
  }

  create_new_greenhouse() {
    const {updated_properties} = this.state
    const {dispatch} = this.props;
    const errors = this.validate_new_greenhouse_fields(updated_properties);
    if (Object.keys(errors).length > 0) {
      this.setState({ field_errors: errors });
      dispatch(sweetAlertActions.danger({ title: "Missing Fields", content: <div>{Object.values(errors).map((msg, i) => <div key={i}>{msg}</div>)}</div> }));
      return;
    }
    mapService.createGreenhouse(updated_properties["name"], updated_properties["client_name"], updated_properties["location_id"], res => {
        dispatch(sweetAlertActions.success({
          title: "Greenhouse is created.",
          content: <div>
            <h4>The map id has been autogenerated: {res.map_id}</h4>
          </div>}
        ))
        update_greenhouse_list()
        this.setState({
          updated_properties: {},
          create_greenhouse: false,
          field_errors: {}
        }, () => this.refresh())
      }, error => {
        dispatch(sweetAlertActions.danger({ title: "Error creating the greenhouse" }))
      },
      updated_properties["crop_type"]
    )
  }

  render() {
    const {locations} = this.props
    const {
      update_greenhouse,
      currentPage,
      data,
      pageSize,
      loading,
      totalResults,
      totalPages,
      create_greenhouse,
      updated_properties,
      field_errors,
      crop_types,
      show_deactivated
    } = this.state

    let filler_size = (currentPage - 1) * pageSize
    if (filler_size < 0) {
      filler_size = 0
    }
    let filler_array = Array(filler_size).keys()

    return (
      <GridContainer>
        {create_greenhouse &&
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader>
                <GridContainer>
                  <GridItem xs={10}>
                    <h4 style={{color: primaryColor}}><b>{"Create Greenhouse"}</b></h4>
                  </GridItem>
                </GridContainer>
              </CardHeader>
              <CardBody>
                <div>
                  <CustomInput
                    style={{
                      fullWidth: true,
                      width: "100%"
                    }}
                    id={"name"}
                    labelText={"Name"}
                    inputProps={{
                      onChange: event => this.change_value("name", event.target.value),
                      type: "text",
                      value: updated_properties["name"]
                    }}
                  />
                  {field_errors["name"] && <div style={{ color: 'red', fontSize: 12, marginTop: 2 }}>{field_errors["name"]}</div>}
                  <CustomInput
                    style={{
                      fullWidth: true,
                      width: "100%"
                    }}
                    id={"client_name"}
                    labelText={"Client Name"}
                    inputProps={{
                      onChange: event => this.change_value("client_name", event.target.value),
                      type: "text",
                      value: updated_properties["client_name"]
                    }}
                  />
                  <MyDropdown
                    input_label={"Crop Type"}
                    name={"crop_type"}
                    value={updated_properties["crop_type"]}
                    handle_selection={
                      this.change_value.bind(this)
                    }
                    options={[
                      ...Object.keys(crop_types).map((crop_type_id) => {
                        return {
                          id: crop_type_id,
                          value: crop_types[crop_type_id]
                        }
                      })
                    ]}
                  />
                  <MyDropdown
                    input_label={"Location"}
                    name={"location_id"}
                    value={updated_properties["location_id"]}
                    handle_selection={
                      this.change_value.bind(this)
                    }
                    options={[
                      ...Object.keys(locations).sort((a, b) => {
                        return locations[a]["name"] < locations[b]["name"] ? -1 : 1
                      }).map((location_id) => {
                        return {
                          id: location_id,
                          value: locations[location_id]["name"]
                        }
                      })
                    ]}
                  />
                {field_errors["location_id"] && <div style={{ color: 'red', fontSize: 12, marginTop: 2 }}>{field_errors["location_id"]}</div>}
                </div>
                <Button simple color={"primary"} onClick={this.create_new_greenhouse.bind(this)}> Create </Button>
                <Button simple color={"danger"} onClick={() => {
                  this.setState({create_greenhouse: false, updated_properties: {}})
                }}> Cancel </Button>
              </CardBody>
            </Card>
          </GridItem>
        }
        {update_greenhouse &&
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader>
                <GridContainer>
                  <GridItem xs={10}>
                    <h4 style={{color: primaryColor}}><b>{"Create Greenhouse"}</b></h4>
                  </GridItem>
                </GridContainer>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12}>
                    <p><b>Leave empty if you do not want to update the property</b></p>
                  </GridItem>
                  <GridItem xs={12}>
                    <Table
                      tableData={[
                        [
                          <p><b>Name:</b> {update_greenhouse["name"]}</p>,
                          <CustomInput
                            style={{
                              fullWidth: true,
                              width: "100%"
                            }}
                            id={"name"}
                            labelText={"New name"}
                            inputProps={{
                              onChange: event => this.change_value("name", event.target.value),
                              type: "text",
                              value: updated_properties["name"]
                            }}
                          />
                        ],
                        [
                          <p><b>Client Name:</b> {update_greenhouse["client_name"]}</p>,
                          <CustomInput
                            style={{
                              fullWidth: true,
                              width: "100%"
                            }}
                            id={"client_name"}
                            labelText={"New Client Name"}
                            inputProps={{
                              onChange: event => this.change_value("client_name", event.target.value),
                              type: "text",
                              value: updated_properties["client_name"]
                            }}
                          />
                        ],
                        [
                          <p><b>Map ID:</b> {update_greenhouse["map_id"]}</p>,
                          <CustomInput
                            style={{
                              fullWidth: true,
                              width: "100%"
                            }}
                            id={"map_id"}
                            labelText={"New Map ID"}
                            inputProps={{
                              onChange: event => this.change_value("map_id", event.target.value),
                              type: "text",
                              value: updated_properties["map_id"]
                            }}
                          />
                        ],
                        [
                          <p><b>Crop Type:</b> {update_greenhouse["crop_type"]}</p>,
                          <MyDropdown
                              input_label={"Crop Type"}
                              name={"crop_type"}
                              value={updated_properties["crop_type"]}
                              handle_selection={
                                this.change_value.bind(this)
                              }
                              options={[
                                ...Object.keys(crop_types).map((crop_type_id) => {
                                  return {
                                    id: crop_type_id,
                                    value: crop_types[crop_type_id]
                                  }
                                })
                              ]}
                            />
                        ],
                        [
                          <p>
                            <b>Location Name: </b>
                            {locations[update_greenhouse["location_id"]] ?
                              locations[update_greenhouse["location_id"]]["name"] : update_greenhouse["location_id"]
                            }
                            {getUserType() === "system_admin" &&
                              <p><b>Location ID: </b> {update_greenhouse["location_id"]}</p>
                            }
                          </p>,
                          getUserType() === "system_admin" ?
                            <MyDropdown
                              input_label={"Location"}
                              name={"location_id"}
                              value={updated_properties["location_id"]}
                              handle_selection={
                                this.change_value.bind(this)
                              }
                              options={[
                                ...Object.keys(locations).sort((a, b) => {
                                  return locations[a]["name"] < locations[b]["name"] ? -1 : 1
                                }).map((location_id) => {
                                  return {
                                    id: location_id,
                                    value: locations[location_id]["name"]
                                  }
                                })
                              ]}
                            /> :
                            <p>Can only be updated by your Cloud Manager</p>
                        ],
                        ["", ""],
                      ]}
                    />
                  </GridItem>
                  <GridItem xs={12}>
                    <Button simple color={"primary"}
                            onClick={this.do_update_greenhouse.bind(this, update_greenhouse)}> Update </Button>
                    <Button
                      simple
                      color={"danger"}
                      onClick={() => {
                        this.setState({update_greenhouse: null, updated_properties: {}})
                      }}
                    >
                      Cancel
                    </Button>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        }
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader>
              <GridContainer>
                <GridItem xs={6}>
                  <h4 style={{color: primaryColor}}><b>{"Overview Greenhouses"}</b></h4>
                </GridItem>
                <GridItem xs={6} style={{textAlign: "right", justifyContent: "right"}}>
                  <Button color="primary" simple
                          onClick={this.toggle_show_deactivated.bind(this)}><b>{show_deactivated ? "Hide deactivated": "Show Deactivated"}</b></Button>
                <Button color="primary" simple
                          onClick={this.start_creating_greenhouse.bind(this)}><b>{"Create Greenhouse"}</b></Button>
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
              <h5># Results: {totalResults}</h5>
              <ReactTable
                columns={
                  [
                    {
                      Header: "ID",
                      accessor: "id",
                      filterable: false,
                      sortable: false,
                      maxWidth: 50,
                      Cell: row => {
                        return <ClipboardButton text={row.value}/>
                      }
                    },
                    {
                      Header: "Name",
                      accessor: "name",
                    },
                    {
                      Header: "Client Name",
                      accessor: "client_name",
                    },
                    {
                      Header: "Location",
                      accessor: "location_id",
                      Cell: row => {
                        if (locations && locations[row.value]) {
                          return locations[row.value]["name"]
                        }
                        return row.value
                      }
                    },
                    {
                      Header: "Map ID",
                      accessor: "map_id",
                    },
                    {
                      Header: "Crop Type",
                      accessor: "crop_type",
                      Cell: row => {
                        if (crop_types && crop_types[row.value]) {
                          return crop_types[row.value]
                        }
                        return row.value ? `Unknown Type: ${row.value}` : "No type specified"
                      }
                    },
                    {
                      Header: "Actions",
                      accessor: "id",
                      Cell: row => {
                        return <>
                          {row.original.deactivated ?
                            <>
                            {getUserType() === "system_admin" ?
                              <Button
                                color="warning"
                                simple
                                onClick={this.start_activating_greenhouse.bind(this, row.original)}
                              >
                                <b>{"Activate"}</b>
                              </Button> :
                              <p>Contact your Nimbus System Manager to activate again.</p>
                            }
                            </>:
                            <>
                              <Button
                                color="primary"
                                simple
                                onClick={this.start_updating_greenhouse.bind(this, row.original)}
                              >
                                <b>{"Update"}</b>
                              </Button>
                              <Button
                                color="danger"
                                simple
                                onClick={this.start_deactivating_greenhouse.bind(this, row.original)}
                              >
                                <b>{"Deactivate"}</b>
                              </Button>
                            </>
                          }
                        </>
                        }
                    }
                  ]}
                data={[
                  ...filler_array,
                  ...data
                ]}
                sortable={false}
                filterable={false}
                loading={loading}
                pages={totalPages}
                page={currentPage - 1}
                pageSize={pageSize}
                onPageChange={(pageIndex) => this.setState({currentPage: pageIndex + 1}, () => this.refresh())}
                onPageSizeChange={(newPageSize) => {
                  this.setState({currentPage: 1, pageSize: newPageSize}, () => this.refresh())
                }}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    )
  }
}


function mapStateToProps(state) {
  const {locations} = state.location
  return {
    locations
  }
}


export default withStyles(extendedTablesStyle)(connect(mapStateToProps)(Greenhouses))
